import { Stack } from '@mui/material'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
interface IExpiredLicense {
	mt?: string
	availableLicenceDates?: string
	isShowEmptyData?: boolean
}
export const ExpiredLicense = (props: IExpiredLicense) => {
	const { mt = '', availableLicenceDates, isShowEmptyData = true } = props
	return (
		<Stack
			direction={'column'}
			justifyContent={'center'}
			alignItems={'center'}
			gap={'12px'}
			height={'100%'}
			mt={mt}
		>
			{isShowEmptyData && (
				<TypographySecondary14 sx={{ fontWeight: 700 }}>
					Нет данных
				</TypographySecondary14>
			)}
			<Stack
				direction={'column'}
				justifyContent={'center'}
				alignItems={'center'}
			>
				<TypographySecondary14>
					Истек срок лицензионного соглашения.
				</TypographySecondary14>
				{availableLicenceDates && (
					<TypographySecondary14>{availableLicenceDates}</TypographySecondary14>
				)}
			</Stack>
		</Stack>
	)
}
